import { useTranslation } from 'react-i18next';
import { useMFAStore } from '../../stores/mfaStore';
import { useState } from 'react';
import { Button } from '../common/Button';

export function AuthMFA({ onVerified }: { onVerified: () => void }) {
  const { t } = useTranslation(['auth', 'settings']);
  const { code, setCode, error, challengeAndVerify, markMfaVerified } = useMFAStore();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    const success = await challengeAndVerify();
    if (success) {
      markMfaVerified();
      onVerified();
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 items-center justify-center min-h-screen">
      <p>{t('authCTAVerify', { ns: 'auth' })}</p>
      {error && <div className="text-red-500">{t('authCTAGenericError', { ns: 'auth' })}</div>}
      <input
        type="text"
        className="w-1/2 bg-[#E1E9F0] rounded px-10 py-3 font-ambit text-base text-secondary border-none focus:outline-none"
        placeholder={t('codePlaceholder', { ns: 'auth' })}
        value={code}
        onChange={e => setCode(e.target.value.trim())}
      />

      <Button
        onClick={handleSubmit}
        type="button"
        variant="primary"
        className="w-full mt-8"
        disabled={loading || code.length !== 6}
      >
        {loading ? t('saving', { ns: 'auth' }) : t('improveProfileStep.save', { ns: 'auth' })}
      </Button>
    </div>
  );
}
